<template>
    <div class="head-top">
      <div class="head-top-bg">
        <div class="head-top-bg-box">
          <div class="logo"><img src="../../../static/img/ts-img/logo.png" alt=""></div>
          <p class="txt">中国学术不端论文查重检测系统多语种、图文、抄袭高校论文查重检测系统</p>
        </div>
      </div>
      <div class="head-top-nav" v-show="isShow">
        <ul class="head-top-nav-box">
          <li :class="navActive == 0? 'active':''" @click="navLinkFun('/')">
            <span>首页</span>
          </li>
          <li :class="navActive == 1? 'active':''">
            <span @click="navClickFun(14,'/descriptionFirst/')">查重系统简介</span>
            <div class="select-nav">
              <p v-for="item in descriptionNav" :key="item.id"  @click="descriptionnavClickFun(item.id)">{{item.name}}</p>
            </div>
          </li>
          <li :class="navActive == 2? 'active':''">
            <span @click="navLinkFun('/chSystem/')">论文查重</span>
            <div class="select-nav">
              <p v-for="i in chSystemNav" :key="i.id" @click="chSystemNavClickFun(i.id)">{{i.title}}</p>
            </div>
          </li>
          <li :class="navActive == 3? 'active':''" @click="navLinkFun('/reportDownload/')">
            <span>查重报告下载</span>
          </li>
          <li :class="navActive == 4? 'active':''">
            <span @click="navLinkFun('/newsList/')">查重资讯</span>
            <div class="select-nav">
              <p v-for="item in newsListNav" :key="item.id" @click="navClickFun(item.id,'/newsList/')">{{item.name}}</p>
            </div>
          </li>
          <li :class="navActive == 5? 'active':''">
            <span> <a href="http://check7.cnki.net/codeverify/" target="_blank">查重报告真伪验证</a></span>
          </li>
          <li :class="navActive == 6? 'active':''">
            <span @click="navLinkFun('/paperRevision/')">论文修改</span>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
  import tool from '../../assets/js/tool.js'
  import {
    mapState,
  } from 'vuex'
    export default {
        name: "head-top",
        data () {
          return {
            subNavH: 0, //下拉导航高度
            descriptionNav: '', //查重系统简介导航
            newsListNav: '', //知网查重资讯导航
            chSystemNav: '', //知网查重
            productInner: '', //查重产品信息
          }
        },
        props: {
          navActive:{
            type: Number,
            default: 0
          }, //当前页导航
          isShow:{
            type: Boolean,
            default: true
          }, //是否显示导航
        },
        computed: {
          ...mapState(['headNavLink'])
        },
        methods: {
          /* 下拉导航鼠标滑入效果 */
          navOverFun () {
            this.subNavH = '200px'
          },
          /* 下拉导航鼠标滑出效果 */
          navOutFun () {
            this.subNavH = '0'
          },

          //链接跳转
          navLinkFun (url) {
            this.$router.push({
              path: url,
            })
          },

          /* 导航点击事件 */
          navClickFun (id,url) {
            this.$emit ('navClick', id);
            this.$router.push({
              path: url,
              query: {
                id:id
              }
            })
          },

          /* 获取基本信息 */
          // getBasicInfo () {
          //   let data = {
          //
          //   };
          //   tool.postData('get_setting',data,(res) => {
          //     this.logoImg = res.data.data.logo_top;
          //   });
          // },
          /* 查重系统简介 */
          descriptionNavFun () {
            let data = {
              parent_id : 11
            };
            tool.postData('get_category_two',data,(res) => {
              this.descriptionNav = res.data.data.category_list;
            });
          },
          /* 查重咨讯 */
          newsListNavFun () {
            let data = {};
            tool.postData('get_info_list',data,(res) => {
              this.newsListNav = res.data.data.category_two;
            });
          },
          /* 论文查重 */
          chSystemNavFun () {
            let data = {};
            tool.postData('get_goods_list',data,(res) => {
              this.chSystemNav = res.data.data.goods_list.data;
            });
          },
          /* 导航点击进去FQA页面 */
          descriptionnavClickFun (id) {
            if (id == 13) {
              this.$emit ('navClick', id);
              this.$router.push({
                path: '/descriptionThird/',
                query: {
                  id:id
                }
              })
            }else{
              this.$emit ('navClick', id);
              this.$router.push({
                path: '/descriptionFirst/',
                query: {
                  id:id
                }
              })
            }
          },

          /* 查重产品导航 */
          chSystemNavClickFun (id) {
            let data = {
              goods_id: id
            };
            tool.postData('get_goods_detail',data,(res) => {
              this.productInner = res.data.data;
              this.$emit('navClick', this.productInner);
            });
            this.$router.push({
              path: '/chSystemDetail/',
              query: {
                id: id
              }
            });
           this.$router.go(0)
          }
        },
      mounted () {
        // this.getBasicInfo();
        this.descriptionNavFun();
        this.newsListNavFun();
        this.chSystemNavFun();
      }
    }
</script>

<style scoped lang="scss">
@import "../../assets/style/common";
  .head-top-bg{
    width: 100%;
    height: 90px;
    background: url("../../../static/img/top.png") no-repeat;
    background-size: cover;
    .head-top-bg-box{
      width: $box-width;
      height: 90px;
      margin: 0 auto;
      @include flex;
      .logo{
        width: 120px;
        height:45px;
        padding: 10px;
        img{
          height: 100%;
        }
      }
      .txt{
        @include font(20px,#fff);
        font-weight: bold;
      }
    }
  }
  .head-top-nav-box{
    width: $box-width;
    height: 52px;
    margin: 0 auto;
    display: flex;
    li{
      width: 162px;
      height: 52px;
      @include font(16px,#333);
      padding-bottom: 2px;
      cursor: pointer;
      span{
        width: 93%;
        display: block;
        margin: 0 auto;
        line-height: 52px;
        text-align: center;
        border-bottom: 1px solid transparent;
        a{
          color: #333;
        }
      }
      &.active,&:hover{
        background-color: #3b6bda;
        color: #fff;
        a{
          color: #fff;
        }
      }
      &.active{
        span{
          border-bottom: 1px solid #fff;
        }
      }
      span:hover{
        border-bottom: 1px solid #fff;
      }
      &:hover{
        .select-nav{
          opacity: 1;
          height: auto;
        }
      }
      .select-nav{
        width: 100%;
        height: 0;
        overflow: hidden;
        background-color: #3b6bda;
        opacity: 0;
        transition: all .7s;
        padding-bottom: 2px;
        position: relative;
        z-index: 1;
        p{
          width: 95%;
          margin: 0 auto;
          text-align: center;
          line-height: 55px;
          @include font(16px,#fff);
          border-bottom: 1px solid transparent;
        }
        p:hover{
          border-bottom: 1px solid #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/head-top.vue